import $ from 'jquery'
if (!SOPHIA.publisher) { SOPHIA.publisher = {}; }

SOPHIA.publisher.CollectionTutorialPublisher = function(id) {

  var contentId = id,
      $publishingBar = $('#publishing-form'),
      publishingState = SOPHIA.publisher.publishingState;

  $('input[name=publishing]', $publishingBar).on('click', function(e) {
    e.preventDefault();
    switch ($(e.target).val()) {
      case 'unpublished':
        return unpublish();
      case 'world':
        return publishToWorld();
    }
  });

  function publishToWorld() {
    var xhrData = {
      url:  SOPHIA.Routes.publish_to_world_path(contentId),
      type: 'post'
    };

    var callbacks = {
      afterSuccess: function(result) {
        if (result.success) {
          _checkRadioButton('world');
          publishingState.setState('public');
        }
      }
    };

    SOPHIA.sendXHR(xhrData, callbacks);
  }

  function unpublish() {
    var xhrData = {
      url:  SOPHIA.Routes.unpublish_path(contentId),
      type: 'delete'
    };

    var callbacks = {
      afterSuccess: function(result) {
        if (result.success) {
          _checkRadioButton('unpublished');
          publishingState.setState('unpublished');
        }
      }
    };

    SOPHIA.sendXHR(xhrData, callbacks);
  }

  function _checkRadioButton(name) {
    $("input[name=publishing]", $publishingBar).prop('checked', false);
    $("input[name=publishing][value=" + name+ "]", $publishingBar).prop('checked', true);

    if (name === 'group') {
      $('.see-groups-link', $publishingBar).show();
    } else {
      $('.see-groups-link', $publishingBar).hide();
    }
  }
};
